import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { I as IconButton } from '../Button/IconButton/IconButton-CAx4y7vS.js';
import { l as longArrowUp } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const SendButton = ({
  onClick,
  disabled,
  isActive = false
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'send-button'
  });
  const sendMessageLabel = formatMessage({
    id: 'action-send'
  });
  return /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getDataTaktAttributes(), {
    variant: "primary",
    onClick: onClick,
    disabled: disabled || !isActive,
    icon: longArrowUp,
    label: sendMessageLabel,
    title: sendMessageLabel,
    small: true
  }));
};

export { SendButton as S };
//# sourceMappingURL=SendButton-Cs-a7R7r.js.map
